/** Small, dependency-free random helpers used across world generation. */

/** Uniform float in the range [min, max). */
export function randFloat(min: number, max: number): number {
  return min + Math.random() * (max - min);
}

/** Uniform integer in the range [0, count). */
export function randInt(count: number): number {
  return Math.floor(Math.random() * count);
}

/** Returns a random element from a non-empty array. */
export function pick<T>(items: readonly T[]): T {
  return items[randInt(items.length)];
}

/** Returns true with the given probability (0..1). */
export function chance(probability: number): boolean {
  return Math.random() < probability;
}
